// src/pages/PagamentoSucesso.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PagamentoSucesso() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => { setVisible(true); }, []);

  return (
    <div className="min-h-screen flex flex-col bg-muted/30">
      <Header />
      <main className={`flex-1 flex items-center justify-center px-4 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <div className="bg-card rounded-2xl shadow-card p-8 md:p-12 text-center max-w-md w-full">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl font-display font-bold text-foreground mb-2">Pagamento confirmado!</h1>
          <p className="text-muted-foreground mb-6">Seu plano foi ativado automaticamente. Agora você tem acesso completo aos resultados.</p>
          <button
            onClick={() => navigate('/orcamento/novo?tipo=cub')}
            className="w-full bg-primary text-white py-3 rounded-xl font-bold text-sm hover:bg-primary/90 transition-all"
          >
            Começar a usar →
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full mt-3 text-sm text-muted-foreground hover:text-foreground transition-all"
          >
            Voltar para o início
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
